<template>
  <div ref="container" class="react" />
</template>

<script>
  import { createElement } from 'react'
  import { createRoot } from 'react-dom/client'
  import { mapGetters } from 'vuex'
  import Permission from '@/utilities/auth/permission/Permission'
  import { wrap } from '../react-migration/src/components/utils/wrap'

  export default {
    inheritAttrs: false,
    props: {
      component: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        reactRoot: null,
      }
    },
    watch: {
      $attrs: {
        deep: true,
        handler() {
          this.updateReactComponent()
        },
      },
    },
    mounted() {
      this.reactRoot = createRoot(this.$refs.container)
      this.updateReactComponent()
    },
    destroyed() {
      this.reactRoot.unmount()
    },
    computed: {
      ...mapGetters('Auth', ['permissions', 'role']),
      perms: vm => new Permission(vm.permissions),
    },
    methods: {
      updateReactComponent() {
        // wrap class simulates "react app with all the providers"
        this.reactRoot.render(
          createElement(
            wrap,
            {
              permission: this.perms, // Pass in permissions object
              role: this.role,
            },
            createElement(this.component, this.$attrs),
          ),
        )
      },
    },
  }
</script>
